import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { fetchBusinessSettings } from '../actions/business_settings'
import { updateBusinessSettings } from '../actions/update_business_settings'
import { transactionRestart, transactionResetErrorMessage } from '../actions/transaction_restart'
import { getUser } from '../actions/users'
import BusinessEditFormComponent from '../components/business_settings/business_settings_edit_form'
import Spinner3Bounce from '../components/spinner_3_bounce'

export class BusinessSettings extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      business: null,
      id: null,
    }
  }

  onCancel = async () => {
    this.props.transactionResetErrorMessage()
    this.props.fetchBusinessSettings(this.state.id)
  }

  onSave = async (settings) => {
    const { props, state } = this
    try {
      props.transactionResetErrorMessage()
      await props.updateBusinessSettings(state.id, props.settings[0].id, settings)
      await props.fetchBusinessSettings(state.id)
    } catch (e) {
      console.log(e)
    } finally {
      this.setState({ business: null })
    }
  }

  onRestart = async () => {
    const { props, state } = this
    try {
      await props.transactionRestart(state.id)
      await props.fetchBusinessSettings(state.id)
    } catch (e) {
      console.log(e)
    } finally {
      this.setState({ business: null })
    }
  }

  async componentDidMount() {
    const { fetchBusinessSettings, getUser } = this.props
    const result = await getUser()
    this.setState({ id: result.response.business })
    fetchBusinessSettings(result.response.business)
  }

  render() {
    const { props } = this
    if (props.isFetching || props.isUserFetching || props.isTransactionRestartFetching) {
      return (
        <div className='text-center grid-spinner-mt-240'>
          <Spinner3Bounce isActive />
        </div>
      )
    }
    if (props.settings) {
      return (
        <BusinessEditFormComponent
          onRestart={this.onRestart}
          data={props.settings}
          business={props.settings[0]}
          errorMessage={props.errorMessage || props.transactionErrorMessage}
          onCancel={this.onCancel}
          onSave={this.onSave}
        />
      )
    }
  }
}

const mapStateToProps = (state, ownProps) => ({
  transactionErrorMessage: state.transactionRestart.errorMessage,
  isTransactionRestartFetching: state.transactionRestart.isFetching,
  isFetching: state.businessSettings.isFetching,
  isUserFetching: state.getUser.isFetching,
  isUpdateBusinessFetching: state.updateBusinessSettings.isFetching,
  settings: state.businessSettings.settings,
  errorMessage: state.updateBusinessSettings.errorMessage,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchBusinessSettings,
      transactionResetErrorMessage,
      transactionRestart,
      getUser,
      updateBusinessSettings,
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(BusinessSettings)
